import { Appointment } from "@elixir/types";
import { ChipWithTooltip, TooltipComponent } from "ui";
import { Dropdown, Menu } from "antd";
import { FlaskRegularIcon, PillsSolidIcon } from "@elixir/icons";
import {
  isCanBookLabTest,
  isCanOrderMedicine,
  onBookLabTestAction,
  onOrderMedicineAction,
} from "../../../../utils/bridges/methods";
import { useEffect, useState } from "react";

const OrderMedicineButton = ({
  apt,
  className = "",
  type,
}: {
  apt: Appointment;
  className?: string;
  type?: "primary" | "secondary";
}) => {
  const [isCanPlaceOrder, setIsCanPlaceOrder] = useState<boolean>(true);
  const [isCanBookLabTestFlag, setIsCanBookLabTestFlag] =
    useState<boolean>(false);

  useEffect(() => {
    const fetch = async () => {
      const placeOrderFlag = await isCanOrderMedicine();
      const res = await isCanBookLabTest();
      setIsCanBookLabTestFlag(res);
      setIsCanPlaceOrder(placeOrderFlag);
    };
    fetch();
  }, []);

  const menu = (
    <Menu className="dr-rounded-8 dr-overflow-hidden dr-w-200">
      {isCanPlaceOrder ? (
        <Menu.Item
          onClick={() => {
            onOrderMedicineAction(apt);
          }}
          icon={
            <PillsSolidIcon className="w-20 h-16 dr-text-darwin-touch-neutral-1000" />
          }
        >
          <div className="dr-flex dr-items-center dr-justify-between BodyBody2Regular dr-py-7 dr-text-darwin-touch-neutral-1000">
            Order Medicines
          </div>
        </Menu.Item>
      ) : (
        <></>
      )}
      {isCanPlaceOrder && isCanBookLabTestFlag ? (
        <div className="dr-w-full dr-h-1 dr-bg-doctor-darwin-neutral-100" />
      ) : (
        <></>
      )}
      {isCanBookLabTestFlag ? (
        <Menu.Item
          onClick={() => {
            onBookLabTestAction(apt);
          }}
          icon={
            <FlaskRegularIcon className="w-20 h-16 dr-text-darwin-touch-neutral-1000" />
          }
        >
          <div className="dr-flex dr-items-center dr-justify-between BodyBody2Regular dr-py-7 dr-text-darwin-touch-neutral-1000">
            Book Lab Test
          </div>
        </Menu.Item>
      ) : (
        <></>
      )}
    </Menu>
  );

  return isCanPlaceOrder || isCanBookLabTestFlag ? (
    <TooltipComponent placement="top" title={"Place Order"}>
      <Dropdown trigger={["click"]} overlay={menu} placement="bottomRight">
        <ChipWithTooltip
          title="Order"
          tooltipText="Place Order"
          icon={<PillsSolidIcon />}
          className={className}
          type={type}
        />
      </Dropdown>
    </TooltipComponent>
  ) : null;
};

export default OrderMedicineButton;
